import { fetchCurrentUser } from '../../../../ducks/user.duck';
import { storableError } from '../../../../util/errors';

// ================ Action types ================ //

export const FETCH_FAVORITES_REQUEST = 'app/FavoritesPage/FETCH_FAVORITES_REQUEST';
export const FETCH_FAVORITES_SUCCESS = 'app/FavoritesPage/FETCH_FAVORITES_SUCCESS';
export const FETCH_FAVORITES_ERROR = 'app/FavoritesPage/FETCH_FAVORITES_ERROR';

// ================ Reducer ================ //

const initialState = {
  queryInProgress: false,
  queryFavoritesError: null,
  favoriteLists: [],
};

const favoritesPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_FAVORITES_REQUEST:
      return {
        ...state,
        queryInProgress: true,
        queryFavoritesError: null,
        favoriteLists: []
      };
    case FETCH_FAVORITES_SUCCESS:
      return {
        ...state,
        favoriteLists: payload.data.attributes.profile.metadata.favoriteLists,
        queryInProgress: false,
      };
    case FETCH_FAVORITES_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, queryInProgress: false, queryFavoritesError: payload, favoriteLists: [] };

    default:
      return state;
  }
};

export default favoritesPageReducer;

// ================ Action creators ================ //

export const queryFavoritesRequest = () => ({
  type: FETCH_FAVORITES_REQUEST,
});

export const queryFavoritesSuccess = response => ({
  type: FETCH_FAVORITES_SUCCESS,
  payload: { data: response.data },
});

export const queryFavoritesError = e => ({
  type: FETCH_FAVORITES_ERROR,
  error: true,
  payload: e,
});

// Throwing error for new (loadData may need that info)
export const queryFavorites = ({ userId }) => (dispatch, getState, sdk) => {
  dispatch(queryFavoritesRequest());

  return sdk.users.show({ id: userId })
    .then(response => {
      dispatch(queryFavoritesSuccess(response.data));
      return response;
    })
    .catch(e => {
      dispatch(queryFavoritesError(storableError(e)));
      throw e;
    });
};

export const loadData = (params, search, config) => (dispatch) => {
  const userId = params.userId;

  return dispatch(fetchCurrentUser()).then(() =>
    dispatch(
      queryFavorites({
        userId,
      })
    )
  );
};
